/* tslint:disable */

import { CMSResource } from "app/resources/cmsresource";
import { AvailableAppointmentResource } from "./AvailableAppointmentResource";

export class AvailableAppointmentListResource extends CMSResource {

	availableDates: AvailableAppointmentResource[]

}
